import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.scss'; // Assuming UK version uses the same styles
// Removed flowchart import as it might not be relevant or needs updating for UK

function AboutUK() { // Renamed component
  const NavButton = ({ to, children, primary }) => (
    <Link
      to={to}
      className={`nav-button ${primary ? 'nav-button-primary' : 'nav-button-secondary'}`}
    >
      {children}
    </Link>
  );

  return (
    <div className="about-container">
      <div className="back-nav">
        {/* Adjust link if UK landing page path is different */}
        <NavButton to="/uk" primary>← Back </NavButton>
      </div>

      <h1>About Pulc.ai</h1>

      <section className="about-section">
        <h2>Our Mission</h2>
        <p>
          We want to end education inequality. We believe that AI can help us achieve this.
        </p>
        <p>
          Right now, students are placed under immense pressure to fork out for expensive tutoring, to learn off
          large chunks of material and to pay for sample essays. This isn't education.
          {/* Adjusted wording from 'grinds' and removed 'H1' */}
        </p>
        <p>
          Pulc trains you to write perfect essays. It grades your work, gives feedback and shows you exactly how
          an examiner would mark it. Then it helps you revise it to make it better and better.
        </p>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li>No more expensive tutoring</li> {/* Adjusted wording */}
          <li>No more rote learning</li>
          <li>No more "Sample Essays"</li> {/* Removed 'H1' */}
        </ul>
      </section>


      <div className="cta-section">
        <h2>Try it now!</h2>
        {/* Adjust links if UK registration/login paths differ */}
        <NavButton to="/register">Create an Account</NavButton>
        <NavButton to="/login" primary>Login</NavButton>
      </div>

      <section className="about-section">
        <h2>Who are we?</h2>
        <p>
          We're Charles and Cillian. We're trying to improve education fairness.
          We think AI can help make the system more equal.
          {/* Generalized the statement */}
        </p>

        <h3>Cillian</h3>
        <p>
          I'm a university lecturer. I write papers about the philosophy of technology
          (including AI) and political philosophy. I did my PhD at the University of Cambridge and I've worked
          at prestigious universities across Europe.
          {/* Removed location and anecdote about selling notes */}
        </p>

        <h3>Charles</h3>
        <p>
          I studied maths at Trinity College, Dublin. I spent the last decade working in quantitative finance.
          I've taught everyone from 5-year-olds to university students. I'm really excited about the potential
          for AI to make education more effective, more creative and more enjoyable for everyone.
          {/* Removed location */}
        </p>
      </section>

      <section className="about-section">
        <h2>Your Data</h2>
        <p>
          With AI, protecting your data is more important than ever. We want to ensure yours stays safe.
        </p>
        <p>Pulc will never:</p>
        <ul>
          <li>Sell your Personal Data.</li>
          <li>Share it With a Third Party for Advertising.</li>
          <li>Reveal Any Personal or Sensitive Information.</li>
        </ul>
        <p>
          We do need to use your essays to revise our model and make it better. This is just to make sure that
          we are giving a consistent grade and to make it more accurate. When that happens, your data is fully
          anonymised and stored securely.
        </p>
        <p>
          You always have the right to withdraw your data in full and you can do so just by emailing us at:{' '}
          <a href="mailto:hello@pulc.co.uk">hello@pulc.co.uk</a>
        </p>
      </section>

      <div className="cta-section">
        <h2>Try it now!</h2>
        {/* Adjust links if UK registration/login paths differ */}
        <NavButton to="/register">Create an Account</NavButton>
        <NavButton to="/login" primary>Login</NavButton>
      </div>

      <div className="privacy-container">
        <Link to="/privacy" className="privacy-link">
          Privacy Policy
        </Link>
      </div>
    </div>
  );
}

export default AboutUK; // Exporting the renamed component 